import { render, staticRenderFns } from "./ExcDot.vue?vue&type=template&id=09f0cd99&scoped=true&"
import script from "./ExcDot.vue?vue&type=script&lang=ts&"
export * from "./ExcDot.vue?vue&type=script&lang=ts&"
import style0 from "./ExcDot.vue?vue&type=style&index=0&id=09f0cd99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0cd99",
  null
  
)

export default component.exports